import { render, staticRenderFns } from "./CertiQualifyProve.vue?vue&type=template&id=ec4f8e60"
import script from "./CertiQualifyProve.vue?vue&type=script&lang=js"
export * from "./CertiQualifyProve.vue?vue&type=script&lang=js"
import style0 from "./CertiQualifyProve.vue?vue&type=style&index=0&id=ec4f8e60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports